import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useI18n } from "@/lib/i18n";
import { toast } from "sonner";

export default function Login() {
  const { t } = useI18n();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      toast.success(`Welcome, ${user.name}`);
      navigate(user.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="login-page" className="pt-32 pb-24 bg-[#F7F7F6] min-h-screen">
      <div className="max-w-md mx-auto px-6">
        <p className="font-mono-label text-[11px] text-neutral-500 mb-8">[ ACCESS ]</p>
        <h1 className="font-serif-display font-light text-5xl mb-12">{t("auth_login_title")}</h1>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="login-email" required type="email" placeholder={t("auth_email")} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full border border-neutral-300 bg-white px-4 py-4 font-body" />
          <input data-testid="login-password" required type="password" placeholder={t("auth_password")} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full border border-neutral-300 bg-white px-4 py-4 font-body" />
          <button data-testid="login-submit" type="submit" disabled={loading} className="btn-solid w-full justify-center">
            {loading ? "…" : `${t("auth_submit_login")} →`}
          </button>
        </form>
        <p className="mt-8 font-mono-label text-[10px] text-neutral-500">
          {t("auth_no_account")} <Link to="/register" className="text-black underline">{t("auth_register_link")}</Link>
        </p>
      </div>
    </div>
  );
}
